import {useRef} from 'react';
import {Group, Mesh, Vector3} from 'three';
import {useXRHitTest} from '@react-three/xr';
import {hitTestMatrix4, HUMAN_HEIGHT, POS_SKY} from 'lib';
import {useARStore} from 'stores';

const useHitTest = (ref: ReturnType<typeof useRef<Group | Mesh | null>>) => {
  const camera = useARStore(s => s.cameraRef.current);
  const modelActive = useARStore(s => s.modelActive);
  const setHasHitTest = useARStore(s => s.setHasHitTest);

  const heightRef = useRef(HUMAN_HEIGHT);
  const cameraForwardRef = useRef(new Vector3());
  const reticleUpRef = useRef(new Vector3());

  useXRHitTest((results, getWorldMatrix) => {
    if (!ref.current || modelActive.id) {
      return;
    }
    if (results && results.length > 0 && results[0]) {
      setHasHitTest(true);
      getWorldMatrix(hitTestMatrix4, results[0]);
      ref.current.position.setFromMatrixPosition(hitTestMatrix4);
      ref.current.quaternion.setFromRotationMatrix(hitTestMatrix4);
      ref.current.rotateX(-Math.PI * 0.5);
      heightRef.current = Math.abs(ref.current.position.y - camera.position.y);
    } else {
      setHasHitTest(false);
      camera.getWorldDirection(cameraForwardRef.current);
      const forwardMultiplier = -heightRef.current / cameraForwardRef.current.y;
      ref.current.position.copy(cameraForwardRef.current.multiplyScalar(forwardMultiplier).add(camera.position));
      reticleUpRef.current.copy(ref.current.position).add(POS_SKY);
      ref.current.lookAt(reticleUpRef.current);
    }
  }, 'viewer');
};

export default useHitTest;
